import React from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: 'I',
  title: 'El Despertar del Canal',
  emoji: '🌱',
  summary: 'Fundamentos, chakras y tu primera práctica diaria.'
}, {
  num: 'II',
  title: 'Simbología y Distancia',
  emoji: '🔮',
  summary: 'Símbolos sagrados y sesiones a distancia.'
}, {
  num: 'III',
  title: 'La Maestría Espiritual',
  emoji: '✨',
  summary: 'Dai Ko Myo, rejillas de cristales y trabajo profundo.'
}, {
  num: 'IV',
  title: 'El Manual del Iniciador',
  emoji: '🙏',
  summary: 'Sintonizaciones y cómo formar tus estudiantes.'
}, {
  num: 'V',
  title: 'Reiki Business',
  emoji: '💼',
  summary: 'Armá tu práctica profesional y generá ingresos.'
}, {
  num: 'VI',
  title: 'Protocolos de Emergencia',
  emoji: '🚨',
  summary: 'Qué hacer en crisis, dolor agudo y duelo.'
}];
export function HowItWorksSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-197">
      <div className="container mx-auto max-w-3xl" data-id="element-198">
        <div ref={ref1} className={`reveal text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-199">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-3" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-200">
            Los 6 Tomos del Sistema
          </h2>
          <p className="text-gray-400 text-base md:text-lg mb-8" data-id="element-201">
            De cero a Maestro/a — todo lo que necesitás, paso a paso.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4" data-id="element-202">
            {TOMOS.map((tomo, idx) => <div key={idx} className="bg-[#111111] border border-white/5 rounded-xl p-4 flex flex-col items-center text-center gap-2" data-id="element-203">
                <div className="w-10 h-10 rounded-full bg-[#eab308]/10 border border-[#eab308]/30 flex items-center justify-center text-lg" data-id="element-204">
                  {tomo.emoji}
                </div>
                <span className="text-[#eab308] text-[10px] font-bold tracking-widest uppercase" data-id="element-205">
                  TOMO {tomo.num}
                </span>
                <span className="text-white text-xs sm:text-sm font-semibold leading-snug" data-id="element-206">
                  {tomo.title}
                </span>
                <span className="text-gray-400 text-[11px] sm:text-xs leading-snug" data-id="element-207">
                  {tomo.summary}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}